export default "__VITE_ASSET__Co_ilD6I__"